"use strict";

var header = document.querySelector('#section-header');
var headerHeight = header.offsetHeight;
var headerConfig = JSON.parse(header.getAttribute('data-section-settings')); // Do this only if transparent settings is enabled

if (headerConfig['hasTransparentHeader']) {
  // To apply instructions depending to the scroll direction
  scrollDetect();
  header.classList.remove('header--disappear');
}

window.addEventListener('DOMContentLoaded', function () {
  var html = document.querySelector('html');

  if (html.classList.contains('template-index') && window.scrollY == 0) {
    header.classList.add('header-bg-transparent');
    makeHeaderTransparent();
  }
});

function scrollDetect() {
  var lastScroll = 0;
  var initialScroll = window.scrollY;
  var timer = null;
  window.addEventListener('scroll', function () {
    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value

    if (currentScroll >= 0 && lastScroll <= currentScroll) {
      // Scroll down
      if (currentScroll > headerHeight) {
        header.classList.add('header--disappear'); // Hide header

        header.classList.add('header-bg-transparent'); // Apply transparent background on the header
      }

      lastScroll = currentScroll;
      initialScroll = window.scrollY; // Update initialScroll value to make header appear on scroll up
    } else {
      // Scroll up
      if (currentScroll < headerHeight) {
        // Apply transparent background to the header when scroll is smaller than the header height
        header.classList.add('header-bg-transparent');
      } else {
        header.classList.remove('header-bg-transparent');
      }

      lastScroll = currentScroll; // Update initialScroll value

      if (timer !== null) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        initialScroll = window.scrollY;
      }, 300);
    } // Scroll up several px to make header appear


    if (header.classList.contains('header--disappear') && initialScroll - window.scrollY > 100) {
      header.classList.remove('header--disappear');
    }

    makeHeaderTransparent();
  });
}

function makeHeaderTransparent() {
  // Header style depending to the currentScroll and the header class
  var dropdownsNav = document.querySelectorAll('.Header__MainNav .DropdownMenu');
  var linksNav = document.querySelectorAll('.Header__LinkSpacer');

  if (header.classList.contains("header-bg-transparent")) {
    // Set the background to transparent
    dropdownsNav.forEach(function (dropdown) {
      dropdown.classList.add('transparent');
    }); // Set the nav links color to white

    linksNav.forEach(function (linkNav) {
      linkNav.classList.add('white');
    });
  } else {
    // Remove transparent color from dropdowns
    dropdownsNav.forEach(function (dropdown) {
      dropdown.classList.remove('transparent');
    }); // Remove white color from links nav

    linksNav.forEach(function (linkNav) {
      linkNav.classList.remove('white');
    });
  }
}